module.exports = __webpack_public_path__ + "static/media/playroom.e3c246b7.jpg";